routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.quotations', {
      url: "pagos-y-anticipos/cotizaciones/{orderServiceId}",
      template: `<quotations sh-ctrl="shCtrl"></quotations>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/quotations/quotations.config.js
 **/